import React from 'react';
import styled from '../../styled';
import * as ButtonGroup from '../buttonGroup/ButtonGroup';
import { Chevron } from '../icons/outline/Chevron';
import { useIsMobile } from '../../utils';
import { media } from '../../themes/breakpoint';
const HeaderWrapper = styled.div `
  display: inline-flex;
  align-items: center;
  ${media.mobile `
    flex-direction: column;
    align-items: flex-start;
  `};
  & > * {
    margin: 0.875rem 0.5rem 0.875rem 0.5rem;
  }
`;
const TextButtonWrapper = styled.span `
  & > * {
    line-height: 1.25rem;
  }
`;
const BulkAction = ({ checked, interminate, renderTextButton, options, }) => {
    const isMobile = useIsMobile();
    const textButtons = React.useMemo(() => renderTextButton() ? (React.createElement(TextButtonWrapper, null, renderTextButton())) : null, [renderTextButton]);
    const buttonGroup = options.map((option, index) => {
        const Button = ButtonGroup[`${option.buttonType || 'Default'}Button`];
        if (index === 0)
            return (React.createElement(ButtonGroup.CheckboxButton, { key: option.label, width: "MEDIUM", height: "MEDIUM-LARGE", interminate: interminate, checked: checked, onClick: option.onClick }, option.label));
        if (isMobile && option.hideOnMobile)
            return null;
        if (option.isDropdown) {
            return (React.createElement(Button, { key: option.label, width: "MEDIUM", height: "MEDIUM-LARGE", Icon: Chevron, iconPosition: "BOTTOM", iconAlign: "RIGHT", onClick: option.onClick }, option.label));
        }
        return (React.createElement(Button, { key: option.label, width: "MEDIUM", height: "MEDIUM-LARGE", onClick: option.onClick }, option.label));
    });
    return (React.createElement(HeaderWrapper, null,
        React.createElement(ButtonGroup.Wrapper, null, buttonGroup),
        textButtons));
};
export default BulkAction;
//# sourceMappingURL=BulkAction.js.map